@let skills = skillsSg();

@if (skills) {
  <div class="atn-summit-org-chart-node-panel-skills-tab">
    <div class="atn-summit-org-chart-node-panel__table">
      <div class="atn-summit-org-chart-node-panel__table-row">
        <div class="atn-summit-org-chart-node-panel__table-column">
          <div class="atn-summit-org-chart-node-panel__table-column--header">
            Skill
          </div>
        </div>
        <div class="atn-summit-org-chart-node-panel__table-column">
          <div class="atn-summit-org-chart-node-panel__table-column--header">
            Has Certification
          </div>
        </div>
      </div>
      @for (skill of skills; track $index) {
        <div class="atn-summit-org-chart-node-panel__table-row">
          <div class="atn-summit-org-chart-node-panel__table-column">
            {{ skill.name }}
          </div>
          <div class="atn-summit-org-chart-node-panel__table-column">
            {{ skill.hasCertification }}
          </div>
        </div>
      } @empty {
        No skills...
      }
    </div>
  </div>
}
